import Filter from "../Filter/Filter";
import React from "react";
import SearchPanel from "../SearchPanel";
import '../Filter/Filter.scss';
import AgentForm from "../AgentForm/AgentForm";

export default class AgentListFilter extends Filter {
    constructor(props) {
        super(props);
    }

    render() {
        const {query, paneIndex} = this.state;

        return (
            <div ref='main' className='Filter'>
                <div className='Filter_content'>
                    {React.cloneElement(this.props.children, {isSuper: this.props.isSuper}, {isSeniorAgent: this.props.isSeniorAgent})}
                </div>
                <SearchPanel ref='searchPanel'>
                    <nav className='Filter_nav'>
                        <div className='Filter_button' onClick={this.close}>Close</div>
                    </nav>
                    <AgentForm theme='dark'
                                data={query}
                                paneIndex={paneIndex}
                                isFilter={true}
                                handleSubmit={this.handleSubmit}
                                handleCancel={this.clear}
                                handleParentChange={this.handleChange}
                                handleParentDropdownChange={this.handleDropdownChange}
                                handlePaneChange={(key) => this.setState({paneIndex: key})}
                    />
                </SearchPanel>
            </div>
        );
    }
}